'use strict';

var _ = require('lodash');
var moment = require('moment');
function FlightManagementDataRetrieverFilterService(SearchCriteriaRule, FlightManagementSearchCriteria, SearchCriteriaTransformationsService, classFilterBuilderService, featureToggleService, app, flightManagementConstants, dataRetrieverConstantsService) {
  var weekdaysShort = moment.weekdaysShort();
  var weekdays = moment.weekdays();
  function createShortToLongWeekdaysMap() {
    var result = {};
    weekdaysShort.forEach(function (_short, index) {
      result[_short] = weekdays[index];
    });
    return result;
  }
  var shortToLongWeekdaysMap = createShortToLongWeekdaysMap();
  function buildOverbookingFilter(selectedFlights) {
    var filterCriteria = new FlightManagementSearchCriteria();
    var flightDepartureMoment = _.get(selectedFlights, '[0].flightDepartureDateMoment');
    var filters = {
      'custom:leg': _.get(selectedFlights, '[0].leg'),
      'numberDepartureDate': {
        leftOperand: flightDepartureMoment.clone().startOf('day'),
        rightOperand: flightDepartureMoment.clone().endOf('day')
      },
      'number': _.get(selectedFlights, '[0].flightNumber'),
      'scenarioName': 'PUBLISHED',
      'legs.isPartner': 'false'
    };
    var filterRules = _.transform(filters, function (rules, filter, fieldName) {
      var rule = {
        field: fieldName,
        operator: '=',
        leftOperand: filter
      };
      if (fieldName === 'numberDepartureDate') {
        rule.leftOperand = filter.leftOperand;
        rule.rightOperand = filter.rightOperand;
        rule.operator = 'between';
      }
      rules.push(new SearchCriteriaRule(rule));
      return rules;
    }, []);
    filterCriteria.addCriteria(filterRules);
    return {
      filter: filterCriteria.toRSQL(),
      dataDepth: 'SHALLOW'
    };
  }
  function buildFilterCriteria(scenarioName) {
    var filterCriteria = new FlightManagementSearchCriteria();
    filterCriteria.withCurrentSearchCriteria();
    var rule = {
      field: 'legs.isPartner',
      operator: '=',
      leftOperand: false
    };
    filterCriteria.addCriteria(getScenarioRule(scenarioName));
    filterCriteria.addCriteria(new SearchCriteriaRule(rule));
    var segmentSearchCriteria = SearchCriteriaTransformationsService.transformLegFieldsToSegFields(filterCriteria.rules);
    filterCriteria.addCriteria(segmentSearchCriteria);
    return filterCriteria;
  }
  function applyLegCabinGridSelectionFilters(screenState, filterCriteria) {
    if (screenState.filters.selectedLegCabinIds && screenState.filters.selectedLegCabinIds.length > 0) {
      filterCriteria.removeRulesExceptGivenFields(['scenarioName', 'legs.isPartner']);
      filterCriteria.addCriteria(new SearchCriteriaRule({
        field: 'legs.legCabins.legCabinId',
        operator: '=',
        leftOperand: _.cloneDeep(screenState.filters.selectedLegCabinIds)
      }));
      return true;
    }
  }
  function applyLegBarChartSelectionFilter(screenState, filterCriteria) {
    if (screenState.filters.legs && !screenState.filters.legs.areAllBarsSelected) {
      filterCriteria.removeRulesWithGivenField('legs.market');
      filterCriteria.addCriteria(new SearchCriteriaRule({
        field: 'legs.market',
        operator: '=',
        leftOperand: _.cloneDeep(screenState.filters.legs[0])
      }));
    }
  }
  function applyDateRangeChartSelectionFilter(screenState, filterCriteria) {
    if (screenState.filters.dateRange && !screenState.filters.dateRange.areAllBarsSelected) {
      filterCriteria.removeRulesWithGivenField('numberDepartureDate');
      _.forEach(screenState.filters.dateRange[0], function (range) {
        filterCriteria.addCriteria(new SearchCriteriaRule({
          field: 'numberDepartureDate',
          operator: 'Between',
          leftOperand: range.from.toString(),
          rightOperand: range.to.toString()
        }));
      });
    }
  }
  function applyCabinChartSelectionFilter(screenState, filterCriteria) {
    if (screenState.filters.cabin && !screenState.filters.cabin.areAllBarsSelected) {
      filterCriteria.addCriteria(new SearchCriteriaRule({
        field: 'legs.legCabins.cabinCode',
        operator: '=',
        leftOperand: _.cloneDeep(screenState.filters.cabin[0])
      }));
    }
  }
  function applyDowChartSelectionFilter(screenState, filterCriteria) {
    if (screenState.filters.dow && !screenState.filters.dow.areAllBarsSelected) {
      var longDows = _.map(screenState.filters.dow[0], function (shortDow) {
        return shortToLongWeekdaysMap[shortDow];
      });
      filterCriteria.addCriteria(new SearchCriteriaRule({
        field: 'legs.departureDateDOW',
        operator: '=',
        leftOperand: longDows
      }));
    }
  }
  function applySeasonChartSelectionFilter(screenState, filterCriteria) {
    if (screenState.filters.season && !screenState.filters.season.areAllBarsSelected) {
      filterCriteria.addCriteria(new SearchCriteriaRule({
        field: 'legs.legCabins.season',
        operator: '=',
        leftOperand: _.cloneDeep(screenState.filters.season[0])
      }));
    }
  }
  function applyFlightChartSelectionFilter(screenState, filterCriteria) {
    if (screenState.filters.flightLevel && !screenState.filters.flightLevel.areAllBarsSelected) {
      var flightNumbers = _.map(screenState.filters.flightLevel[0], function (flightChartLabel) {
        var parts = _.words(flightChartLabel, /[0-9]+/g);
        return _.parseInt(_.last(parts));
      });
      filterCriteria.addCriteria(new SearchCriteriaRule({
        field: 'number',
        operator: '=',
        leftOperand: flightNumbers
      }));
    }
  }
  function applyFlightAnalysisSelectionCriteria(filterCriteria, screenState) {
    if (!screenState.filters || applyLegCabinGridSelectionFilters(screenState, filterCriteria)) {
      return;
    }
    applyDateRangeChartSelectionFilter(screenState, filterCriteria);
    applyLegBarChartSelectionFilter(screenState, filterCriteria);
    applyCabinChartSelectionFilter(screenState, filterCriteria);
    applyDowChartSelectionFilter(screenState, filterCriteria);
    applySeasonChartSelectionFilter(screenState, filterCriteria);
    applyFlightChartSelectionFilter(screenState, filterCriteria);
  }
  function buildFlightSummaryFilter(scenarioName, noParseCriteria, screenState) {
    var filterCriteria = buildFilterCriteria(scenarioName);
    var queryConfig = _.find(app.dataRetrievalConfigs, {
      attributes: {
        view: dataRetrieverConstantsService.FLIGHT_SCREEN,
        mode: flightManagementConstants.GRIDS.FLIGHT_SUMMARY
      }
    });
    applyFlightAnalysisSelectionCriteria(filterCriteria, screenState);
    return {
      filter: noParseCriteria ? filterCriteria : filterCriteria.toRSQL(),
      maxLimit: _.get(queryConfig, ['properties', 'maxLimit']) || app.maxLimit,
      segClassControls: featureToggleService.isEnabled('SEGMENT_CLASS_CONTROL')
    };
  }
  function buildInventoryManagementFilter(selectedRows, scenarioName) {
    var filterCriteria = new FlightManagementSearchCriteria();
    filterCriteria.addCriteria(classFilterBuilderService.buildFilter(selectedRows));
    filterCriteria.addCriteria(getScenarioRule(scenarioName));
    filterCriteria.withFilter(function (rule) {
      return rule.field === 'legs.legCabins.legCabinId';
    });
    return {
      filter: filterCriteria.toRSQL()
    };
  }
  function buildServiceManagementFilter(selectedFlights) {
    var filterCriteria = new FlightManagementSearchCriteria();
    var legIds = _(selectedFlights).map('legId').uniq().value();
    filterCriteria.addCriteria(new SearchCriteriaRule({
      field: 'legs.legId',
      operator: '=',
      leftOperand: legIds
    }));
    return {
      filter: filterCriteria.toRSQL()
    };
  }
  function getScenarioRule(scenarioName) {
    return new SearchCriteriaRule({
      field: 'scenarioName',
      operator: '=',
      leftOperand: scenarioName || 'PUBLISHED'
    });
  }
  return {
    buildOverbookingFilter: buildOverbookingFilter,
    buildFilterCriteria: buildFilterCriteria,
    buildFlightSummaryFilter: buildFlightSummaryFilter,
    buildInventoryManagementFilter: buildInventoryManagementFilter,
    buildServiceManagementFilter: buildServiceManagementFilter
  };
}
FlightManagementDataRetrieverFilterService.$inject = ['SearchCriteriaRuleFactory', 'FlightManagementSearchCriteriaFactory', 'FlightManagementSearchCriteriaTransformationsService', 'classFilterBuilderService', 'FeatureToggleService', 'App', 'FlightManagementConstants', 'DataRetrieverConstantsService'];
module.exports = FlightManagementDataRetrieverFilterService;